import React from 'react';
import { Button } from 'antd';
import styles from './Footer.module.scss';

const CommentEditingBlock = ({ isSendLoading, onConfirmCancelEdit }) => {
  return (
    <div className={styles.editing}>
      Редактирование комментария
      <Button
        className={styles.cancelEditing}
        style={{ border: 'none' }}
        icon="close"
        size="large"
        onClick={onConfirmCancelEdit}
        disabled={isSendLoading}
      />
    </div>
  );
};

export default CommentEditingBlock;
